
<template>
  <el-card>
    <template #header>
      <content-header />
    </template>
    <el-row
      type="flex"
      justify="center"
    >
      <lz-form
        ref="form"
        :get-data="getData"
        :submit="onSubmit"
        :errors.sync="errors"
        :form.sync="form"
        :edit-mode="editMode"
        :rules="rules"
      >
        <el-form-item
          label="优惠券名："
          required
          prop="title"
        >
          <el-input v-model="form.title" />
        </el-form-item>

        <el-form-item
          label="类型："
          required
          prop="type"
        >
          <el-select
            v-model="form.site"
            placeholder="请选择类型"
            clearable
          >
            <el-option
              v-for="i of site"
              :key="i.value"
              :label="i.label"
              :value="i.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="优惠券类型："
          required
          prop="type"
        >
          <el-select
            v-model="form.type"
            placeholder="选择优惠券类型"
            clearable
          >
            <el-option
              v-for="i of type"
              :key="i.value"
              :label="i.label"
              :value="i.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="订单可用类型："
          required
          prop="order_type"
        >
          <el-select
            v-model="form.order_type"
            placeholder="选择优惠券类型"
            disabled
            clearable
          >
            <el-option
              v-for="i of order_type"
              :key="i.value"
              :label="i.label"
              :value="i.value"
            />
          </el-select>
        </el-form-item>


       <el-form-item
          label="赠送数量"
          v-show="form.site==1"
          required
          prop="give_count"
        >
          <el-input-number
            v-model="form.give_count"
            :precision="0"
            :step="1"
            :max="50"
          />
        </el-form-item>


        <el-form-item
          label="满多少金额"
          v-show="form.type==1"
          required
          prop="with_amount"
        >
          <el-input-number
            v-model="form.with_amount"
            :precision="0"
            :step="0"
            :max="100"
          />
        </el-form-item>
        <el-form-item
          label="可减少金额"

          v-show="form.type!=3&&form.type!=4"
          required
          prop="used_amount"
        >
          <el-input-number
            v-model="form.used_amount"
            :precision="0"
            :step="0"
            :max="50"
          />
        </el-form-item>
        <el-form-item
          label="折扣"
          v-show="form.type==3"
          required
          prop="discount"
        >
          <el-input-number
            v-model="form.discount"
            :min="0"
            :precision="0"
            :step="1"
            :max="100"
          />
        </el-form-item>


        <el-form-item
          label="折扣最多可减少金额(0表示无限制)"
          v-show="form.type==3"
          required
          prop="used_amount"
        >
          <el-input-number
            v-model="form.used_amount"
            :precision="0"
            :step="1"
            :max="20"
          />
        </el-form-item>
        <el-form-item
          label="是否限制发券数量："
          required
          prop="is_quota"
        >
          <el-radio
            v-model="form.is_quota"
            :label="is_limit_times0"
            border
          >不限</el-radio>
          <el-radio
            v-model="form.is_quota"
            :label="is_limit_times1"
            border
          >限量</el-radio>
        </el-form-item>
        <el-form-item
          label="可发券数量："
          v-show="form.is_quota==1"
          required
          prop="quota"
        >
          <el-input-number
            v-model="form.quota"
            :min="0"
            :step="1"
            :max="10000"
          />
        </el-form-item>

        <el-form-item
          label="区域"
          prop="area_id"
        >
          <el-select
            filterable
            clearable
            v-model="form.area_id"
            placeholder="请选择"
          >
            <el-option
              v-for="item in areas"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="发放开始时间"
          required
          prop="grant_start_at"
        >
          <el-date-picker
            v-model="form.grant_start_at"
            type="datetime"
            placeholder="选择日期时间"
          />
        </el-form-item>
        <el-form-item
          label="发放结束时间"
          required
          prop="grant_end_at"
        >
          <el-date-picker
            v-model="form.grant_end_at"
            type="datetime"
            placeholder="选择日期时间"
          />
        </el-form-item>
        <el-form-item
          label="时效类型："
          required
          prop="valid_type"
        >
          <el-radio
            v-model="form.valid_type"
            :label="valid_type1"
            border
          >绝对时效</el-radio>
          <el-radio
            v-model="form.valid_type"
            :label="valid_type2"
            border
          >相对时效</el-radio>
          <el-radio
            v-model="form.valid_type"
            :label="valid_type3"
            border
          >永久</el-radio>
        </el-form-item>
        <el-form-item
          label="生效时间"
          v-show="form.valid_type==1"
          required
          prop="valid_start_time"
        >
          <el-date-picker
            v-model="form.valid_start_time"
            type="datetime"
            placeholder="选择日期时间"
          />
        </el-form-item>
        <el-form-item
          label="失效时间"
          v-show="form.valid_type==1"
          required
          prop="valid_end_time"
        >
          <el-date-picker
            v-model="form.valid_end_time"
            type="datetime"
            placeholder="选择日期时间"
          />
        </el-form-item>
        <el-form-item
          label="得到后有效天数："
          v-show="form.valid_type==2"
          required
          prop="valid_days"
        >
          <el-input-number
            v-model="form.valid_days"
            :min="0"
            :step="1"
            :max="20"
          />
        </el-form-item>
        <el-form-item
          label="是否启用："
          required
          prop="status"
        >
          <el-radio
            v-model="form.status"
            :label="status1"
            border
          >启用</el-radio>
          <el-radio
            v-model="form.status"
            :label="status0"
            border
          >停用</el-radio>
        </el-form-item>
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import LzForm from "@c/LzForm";
import { storeCoupon, editCoupon, updateCoupon } from "@/api/coupon";
import { getAreas } from "@/api/area";
import { getToken } from "@/libs/token";
import FormHelper from "@c/LzForm/FormHelper";

export default {
  name: "Form",
  components: {
    LzForm
  },
  mixins: [FormHelper],
  data() {
    return {
      form: {
        title: "",
        icon: "",
        with_amount: 0,
        used_amount: 0,
        give_count: 0,
        discount: 100,
        order_type: 1,
        type: "",
        site: "",
        is_quota: 0,
        quota: 0,
        grant_start_at: new Date(),
        grant_end_at: new Date(),
        valid_type: 1,
        valid_start_time: new Date(),
        valid_end_time: new Date(),
        valid_days: 0,
        status: 0,
        area_id: ""
      },
      rules: {},
      errors: {},
      areas: [
        {
          id: 0,
          name:"全部"
        }
      ],
      is_limit_times0: 0, // 不限发放数量
      is_limit_times1: 1,
      status1: 1,
      status0: 0,

      valid_type1: 1, // 绝对时效
      valid_type2: 2, // 相对时效
      valid_type3: 3, //永久
      uploadHeaders: {
        Authorization: ""
      },
      site: [
        {
          value:0,
          label: "订单优惠券类型"
        },
        {
          value: 1,
          label: "新用户注册类型"
        }
      ],
      type: [
        {
          value: 1,
          label: "满减优惠券"
        },
        {
          value: 2,
          label: "无门槛优惠券"
        },
        {
          value: 3,
          label: "折扣优惠券"
        },
        {
          value: 4,
          label: "免押金券"
        }
      ],
      order_type: [
        {
          value: 1,
          label: "仅普通订单可用"
        },
        {
          value: 2,
          label: "仅日租订单可用"
        },
        {
          value: 3,
          label: "所有订单可用"
        }
      ]
    };
  },
  created() {
    this.uploadHeaders.Authorization = getToken();
  },
  methods: {
    async onSubmit() {
      if (this.editMode) {
        await updateCoupon(this.resourceId, this.form);
      } else {
        await storeCoupon(this.form);
      }
    },
    async getData() {
      const [{ data: areas }] = await Promise.all([getAreas({ all: 1 })]);

      this.areas = this.areas.concat(areas);
      console.log(this.areas,"区域")

      if (this.editMode) {
        const { data } = await editCoupon(this.resourceId);
        // data.areas = data.areas.map(i => i.id)
        this.fillForm(data);
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },
    handleAvatarSuccess(res, file) {
      this.form.icon = res.path;
      // console.log(res)
    }
  }
};
</script>
<style lang="scss" scoped >
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatara {
  /* width: 178px; */
  height: 178px;
  display: block;
}
</style>
